<template lang="pug">
.context-menu
  .context-menu-dots(ref="dots" @click.stop="toggle") ⋮
  .context-menu-dropdown(v-if="isOpen" ref="dropdown" :style="dropdownStyle")
    .context-menu-item(v-for="(item, index) in items" :key="index" @click.stop="select(item)") {{ item.label }}
</template>

<script>
export default {
  name: 'ContextMenu',

  props: {
    items: { type: Array, default: () => [] }
  },

  data () {
    return {
      isOpen: false,
      dropdownStyle: {}
    }
  },

  watch: {
    isOpen (open) {
      if (open) {
        this.schedulePositionUpdate()
        window.addEventListener('scroll', this.updateDropdownPosition, true)
        window.addEventListener('resize', this.updateDropdownPosition)
      } else {
        this.removePositionListeners()
      }
    },

    items: {
      handler () {
        if (this.isOpen) this.schedulePositionUpdate()
      },
      deep: true
    }
  },

  methods: {
    toggle () {
      this.isOpen = !this.isOpen
    },

    schedulePositionUpdate () {
      this.$nextTick(() => {
        this.updateDropdownPosition()
        this.$nextTick(this.updateDropdownPosition)
      })
    },

    updateDropdownPosition () {
      const dots = this.$refs.dots
      const dropdown = this.$refs.dropdown
      if (!dots || !dropdown) return

      const margin = 8
      const rect = dots.getBoundingClientRect()
      const dropdownHeight = dropdown.offsetHeight
      const dropdownWidth = dropdown.offsetWidth
      const maxHeight = window.innerHeight - margin * 2
      const needsScroll = dropdownHeight > maxHeight

      let top = rect.bottom + 2
      const visibleHeight = needsScroll ? maxHeight : dropdownHeight

      if (top + visibleHeight > window.innerHeight - margin) {
        top = rect.top - visibleHeight - 2
      }
      if (top < margin) {
        top = margin
      }

      let right = window.innerWidth - rect.right
      if (right + dropdownWidth > window.innerWidth - margin) {
        right = window.innerWidth - dropdownWidth - margin
      }
      if (right < margin) right = margin

      this.dropdownStyle = {
        position: 'fixed',
        top: `${top}px`,
        right: `${right}px`,
        left: 'auto',
        zIndex: 13001,
        maxHeight: needsScroll ? `${maxHeight}px` : null,
        overflowY: needsScroll ? 'auto' : null
      }
    },

    removePositionListeners () {
      window.removeEventListener('scroll', this.updateDropdownPosition, true)
      window.removeEventListener('resize', this.updateDropdownPosition)
    },

    select (item) {
      this.isOpen = false
      this.$emit('select', item)
    },

    close () {
      this.isOpen = false
    },

    onDocumentClick (event) {
      if (!this.isOpen) return
      if (this.$el.contains(event.target)) return
      this.close()
    }
  },

  mounted () {
    document.addEventListener('click', this.onDocumentClick, true)
  },

  beforeDestroy () {
    document.removeEventListener('click', this.onDocumentClick, true)
    this.removePositionListeners()
  }
}
</script>

<style lang="stylus">
.context-menu
  position relative

.context-menu-dots
  cursor pointer
  font-size 1.4rem
  font-weight 600
  padding .2em
  user-select none
  letter-spacing .15em

.context-menu-dropdown
  background-color #ffffff
  border 1px solid rgba(0, 0, 0, 0.2)
  box-shadow 0 2px 10px rgba(0, 0, 0, 0.12)
  min-width 10rem
  font-size 1.2rem

.context-menu-item
  padding .5em 1em
  cursor pointer
  white-space nowrap
  text-align left
  &:hover
    background-color rgba(0, 0, 0, 0.1)
</style>



// WEBPACK FOOTER //
// src/components/elements/ContextMenu.vue